
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const githubApiHeaders = {
  // ContentType: "application/json",
  Authorization: `token ${process.env.REACT_APP_GITHUB_ACCESS_TOKEN}`,
};

const baseUrl = "https://api.github.com";

const createRequest = (url) => ({ url, headers: githubApiHeaders });

export const githubApi = createApi({
  reducerPath: "githubApi",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getUserRepos: builder.query({
      query: (username) => createRequest(`/users/${username}/repos?direction=desc&type=public&sort=created&per_page=8`)
    }),
    getUserFollowers: builder.query({
      query: (username) => createRequest(`/users/${username}/followers?direction=desc&per_page=9`)
    }),
    getUserProfile: builder.query({
      query: (username) => createRequest(`/users/${username}`)
    })
  }),
});

export const { useGetUserReposQuery, useGetUserFollowersQuery, useGetUserProfileQuery } = githubApi;
